<template>
  <div class="container">
    <div class="g-p-30">
      <!--  tab1  -->
      <el-tabs v-model="tabNow" @tab-click="tabChange">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待支付" name="0"></el-tab-pane>
        <el-tab-pane label="已支付" name="1"></el-tab-pane>
        <el-tab-pane label="已取消" name="2"></el-tab-pane>
      </el-tabs>

      <div class="data-list" v-loading="loading2">
        <div class="order-item g-rela g-m-t-20" v-for="(item,index) in dataList" :key="index">
          <div class="sn g-font-18 g-p-t-20 g-weight-font">
            {{ '订单编号:' + item.outTradeNo }}
          </div>
          <div class="row-line"></div>

          <div class="g-flex g-row-between g-font-14">
            <!--  待支付  -->
            <p class="orange-text" v-if="item.status === 0">
              <span>您有一个订单将在</span>
              <span class="g-m-l-10 g-m-r-10">{{ item.timeMsg }}</span>
              <span>后自动取消</span>
              <span>，请尽快支付</span>
            </p>
            <!--  已支付  -->
            <p class="orange-text" v-if="item.status === 1">
              订单支付成功，快去学习吧
            </p>
            <!--  已取消  -->
            <p class="orange-text" v-if="item.status === 2">
              您的订单未在规定时间内完成支付被取消了
            </p>
            <p class="remark-text ">{{ item.createTime }}</p>
          </div>
          <div class="info-box g-m-t-10">
            <div class="g-flex g-row-between g-col-top g-p-20">
              <img :src="item.cover" class="order-img" alt="">
              <div class="g-m-l-20 g-m-t-10">
                <p class="g-font-16 main-text">{{ item.name }}</p>
                <p class="g-m-t-10 g-font-12 remark-text">{{ item.desc }}</p>
              </div>
              <div class="g-flex-right g-text-center">
                <div class="red-text money-text g-font-18 g-weight-font" v-if="item.price * 1>0">
                  {{ '￥' + item.price }}
                </div>
                <div class="red-text money-text g-font-18 g-weight-font" v-else>免费</div>
                <!--  待支付  -->
                <div class="submit-btn g-m-t-30" v-if="item.status === 0" @click="doPay(item)">
                  立即支付
                </div>
                <!--  已支付  -->
                <div class="submit-btn g-m-t-30" v-if="item.status === 1"
                     @click="goPage('/course-detail/'+item.courseId)">
                  立即学习
                </div>
                <!--  查看课程  -->
                <div class="submit-btn g-m-t-30" v-if="item.status === 2"
                     @click="goPage('/course-detail/'+item.courseId)">
                  查看课程
                </div>
              </div>
            </div>
          </div>

          <div class="order-status-tag">
            {{ item.statusName}}
          </div>
        </div>
        <!--  分页  -->
        <div class="g-flex g-row-center g-m-t-30">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="params.current"
              :page-sizes="[25, 50, 100]"
              :page-size="params.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!--  付款  -->
    <popup-pay-box ref="payPopup" v-if="showPay" :courseId="courseId" :price="price"
                   @success="queryCourseOrder"></popup-pay-box>
  </div>
</template>

<script>
import {getCourseOrderPageList} from '@/api/pay'
import PopupPayBox from "@/components/pay-popup";

export default {
  name: "my-order",
  data() {
    return {
      tabNow: "all",
      dataList: [],//订单列表
      currentPage: 1,// 当前页
      loading2: false,
      showPay: false,
      params: {
        current: 1,
        size: 25,
        status: null,
      },
      courseId: null,
      price: null,
      total: 0
    }
  },
  components: {PopupPayBox},
  created() {
    this.queryCourseOrder()
  },
  methods: {
    queryCourseOrder() {
      this.loading2 = true
      getCourseOrderPageList(this.params).then(res => {
        this.loading2 = false
        this.total = res.total
        this.dataList = res.records.map(v => {
          this.$set(v, 'countTimer', null)
          this.$set(v, 'timeMsg', null)
          return v
        })
        this.initData()
        this.total = res.total
      }, err => {
        this.loading2 = false
      })

    },
    // 初始化数据倒计时
    initData() {
      for (let i in this.dataList) {
        if (this.dataList[i].timeExpire > 0) {
          this.countDown(i)
          this.dataList[i].countTimer = setInterval(() => {
            this.countDown(i)
          }, 1000)
        }
      }
    },
    tabChange(tab) {
      this.tabNow = tab.name;
      this.params.status = this.tabNow === 'all' ? null : this.tabNow
      this.params.current = 1
      this.dataList = []
      this.queryCourseOrder()

    },
    // 订单 页数切换
    handleSizeChange(val) {
      this.params.size = val
      this.queryCourseOrder()
    },
    // 订单 当前页切换
    handleCurrentChange(val) {
      this.params.current = val
      this.queryCourseOrder()
    },
    // 倒计时
    countDown(i) {
      let m, min, s, second
      if (this.dataList[i].timeExpire > 0) {
        // 分
        m = Math.floor((this.dataList[i].timeExpire / 60) % 60);
        min = m < 10 ? "0" + m : m;
        // 秒
        s = Math.floor(this.dataList[i].timeExpire % 60);
        second = s < 10 ? "0" + s : s;
        this.dataList[i].timeMsg = min + ":" + second;
        this.dataList[i].timeExpire--;
      } else {
        clearInterval(this.dataList[i].countTimer);
      }
    },
    //  跳转
    goPage(path, val) {
      this.$router.push({
        path,
        query: {
          params: val
        }
      })
    },
    //  唤起支付
    doPay(val) {
      this.showPay = true
      this.courseId = val.courseId
      this.price = val.price
      this.$nextTick(() => {
        this.$refs.payPopup.open()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #ffffff;
  border-radius: 5px;
}

::v-deep .el-tabs__item.is-active {
  color: #333;
  font-size: 20px;
  font-weight: 500;
}

::v-deep .el-tabs__item {
  color: #999;
  font-size: 20px;
  font-weight: 500;
}

.info-box {
  background: #f6f6f8;
  border-radius: 5px;
}

.order-item {
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);
  padding: 0 20px 20px;

  .row-line {
    width: 100%;
    height: 1px;
    background: #F7F7F7;
    margin: 10px 0;
  }

  .order-img {
    width: 87px;
    height: 80px;
    border-radius: 5px;
  }

  .submit-btn {
    padding: 6px 22px;
  }

  .order-status-tag {
    position: absolute;
    right: 20px;
    top: 0;
    background: #e9f2ff;
    border-radius: 0 0 10px 10px;
    color: #407AFF;
    font-size: 14px;
    padding: 5px 20px;
  }
}

.money-text {
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
